module.exports = new __parcel__URL__("mvhq_level_4.754e3b6c.png").toString();